export const classNames = Object.freeze({
    // component class names
    labeledDataList: "labeledDataList",
    labeledData: "labeledData",
    labeledDataPart: "labeledData__part",
    labeledDataLabel: "labeledData__label",
    labeledDataData: "labeledData__data",

    // layout class names
    vertical: "labeledDataList--vertical",
    horizontal: "labeledDataList--horizontal",
    centered: "labeledData--centered",
    noSpacing: "labeledDataList--noSpacing",
    inline: "labeledData--inline",

    // framework class names
    decorativeLabel: "decorativeLabel",
    visualLabel: "visualLabel",
    titleMargin: "js-title-margin",
    srOnly: "sr-only",

    // other class names
    selectorLabel: "selectorLabel",
    selectorData: "selectorData",
    legendOption: "legendOption",
    legendOptionLabel: "legendOptionLabel",
    legendOptionData: "legendOptionData",
});
